/**
 * Reveal-on-scroll handler for Quasar's v-intersection directive.
 *
 * Pair with one of the `.reveal-*` classes defined in esign-theme.css:
 *   <section class="reveal-fade-up" v-intersection="revealCfg">
 *
 * The handler toggles `.is-revealed` once the element enters the viewport
 * and returns false so Quasar stops observing afterward.
 *
 * `rootMargin: '0px 0px -15% 0px'` shrinks the bottom of the viewport by
 * 15% of its height - the section must scroll up that far before the
 * animation fires, so reveals happen while the section is meaningfully
 * on-screen rather than the moment its top edge crosses the bottom.
 */
export function onReveal(entry) {
    if (entry.isIntersecting) {
        entry.target.classList.add('is-revealed');
        return false;
    }
}

export const revealCfg = {
    handler: onReveal,
    cfg: { rootMargin: '0px 0px -15% 0px' }
};

/**
 * Drop-in mixin for marketing pages - exposes `revealCfg` on the component
 * so templates can use `v-intersection="revealCfg"` without per-component
 * boilerplate.
 */
export const revealMixin = {
    data() {
        return { revealCfg };
    }
};
